module.exports = __webpack_public_path__ + "img/1f62b.98ab7e6.svg";